import React, { FC, ReactElement } from 'react';

import classnames from 'classnames/bind';
import styles from './emptySkills.module.scss';
const cx = classnames.bind(styles);

interface EmptySkillsProps {
  titleText: ReactElement;
  handleSkillKeyword: () => void;
}

const EmptySkills: FC<EmptySkillsProps> = ({ titleText, handleSkillKeyword }) => {
  return (
    <div className={cx('emptyKeywordArea')}>
      {/* 타이틀 영역 */}
      <div className={cx('titleArea')}>
        <strong className={cx('title')}>{titleText}</strong>
      </div>

      <div className={cx('emptyInner')}>
        <em className={cx('emptyTitle')}>기술 키워드를 입력하면 맞춤 포지션을 추천해드려요.</em>

        <a className={cx('btnSkillKeyword')} role="button" onClick={handleSkillKeyword}>
          기술 키워드 입력하기
        </a>
      </div>
    </div>
  );
};

export default EmptySkills;
